export default function Tech() {
  return (
    <div>
      <h1>Tech</h1>
    </div>
  );
}
